import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import updateFileProviderItemsSelection from './updateFileProviderItemsSelection';
import { action } from 'satcheljs/lib/legacy';
import { lazyEndSearchSession, SearchScenarioId, lazyIsInSearchMode } from 'owa-search';

export default action('closeFilePicker')(async function closeFilePicker(
    maxAllowedLocalFileSize: number,
    viewState: FilePickerPanelViewState
) {
    viewState.isOpen = false;

    // Clear the selection when the file picker is closed
    updateFileProviderItemsSelection(
        [],
        maxAllowedLocalFileSize,
        viewState.selectedFileProvider,
        viewState.filePickerViewState
    );

    const isInSearchMode = await lazyIsInSearchMode.import();
    if (isInSearchMode(SearchScenarioId.FilesPicker)) {
        const endSearchSession = await lazyEndSearchSession.import();
        endSearchSession(SearchScenarioId.FilesPicker);
    }
});
